/* eslint-disable */
import React, { Component } from 'react';
import {
  Alert,
  FormGroup,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  // Media,
} from 'reactstrap';
import ReactImageMagnify from 'react-image-magnify';
import PropTypes from 'prop-types';
// import role from '../../../ProjectConfiguration/role.json';

class SearchReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportID: '',
      reportSerched: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
  }

  onSearchClick() {
    console.log('-------report id--------');
    console.log(this.state.reportID);
    this.props.actions.getReportLink({
      reportId: this.state.reportID,
    });
    this.setState({
      reportSerched: true,
    });
    console.log(this.props.relevantReport);
  }

  handleInputChange(event) {
    this.setState({
      reportID: event.target.value,
    });
  }

  /* eslint class-methods-use-this:0 */


  render() {
    console.log(this.props.relevantReport);
    return (
      <div>
        <FormGroup row className="mt-2">
          <Col md="8">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  Report ID
                </InputGroupText>
              </InputGroupAddon>
              <Input type="text" id="input1-group1" onChange={this.handleInputChange} placeholder="Enter Report ID" value={this.state.reportID && this.state.reportID }/>
            </InputGroup>
          </Col>
          <Col md="4">
            <Button type="submit" color="success" onClick={this.onSearchClick}>Search Report</Button>
          </Col>
        </FormGroup>
        {
            (this.props.relevantReport === null || this.props.relevantReport.imageLink === undefined)
            ?
              ( this.state.reportSerched ?
                <Alert color="warning">
                  Report Not Found
                </Alert>

                :
                <Alert color="success">
                  Enter Report ID and Press Search Report
                </Alert>
              )
            :
                <ReactImageMagnify {...{
                  smallImage: {
                      alt: 'Wristwatch by Ted Baker London',
                      width: 500,
                      height: 500,
                      src: `https://s3.us-west-2.amazonaws.com/${this.props.relevantReport.imageLink.Bucket}/${this.props.relevantReport.imageLink.Key}`,
                  },
                  largeImage: {
                      src: `https://s3.us-west-2.amazonaws.com/${this.props.relevantReport.imageLink.Bucket}/${this.props.relevantReport.imageLink.Key}`,
                      width: 1000,
                      height: 1000,
                  },
                  }}
                />
          }
      </div>
    );
  }
}
SearchReport.defaultProps = {
  actions: null,
  relevantReport: null,
};
SearchReport.propTypes = {
  relevantReport: PropTypes.shape(),
  actions: PropTypes.shape({
    getReportLink: PropTypes.func,
  }),
};

export default SearchReport;



// WEBPACK FOOTER //
// ./src/components/Reports/Search.js